import { Views } from 'components/initial-page/types';

export function isManageInterfaceView(view: Views) {
  return view === Views.Manage || view === Views.Remediations;
}
